module.exports = __webpack_public_path__ + "static/media/YM66_0.8f2bf222.jpg";